import defaultReducer from "./defaultReducer";
import { defaultGrid } from "../../helpers/datagrid";

const initialState = { 
    ...defaultGrid,
    siteDisplay: '',
    machineDisplay: ''
}

export default defaultReducer('VARIANCE_HISTORY_DETAILS_MODAL', initialState);